import Avatar from "@mui/material/Avatar";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {
  getInitialsFromFullName,
  getReadableDateTimeString,
} from "@covertree/utils";

export interface NoteCardProps {
  authorName: string;
  createdDate: string;
  content: string;
}

export function NoteCard({ authorName, createdDate, content }: NoteCardProps) {
  return (
    <Grid
      item
      xs={12}
      container
      p={2}
      borderRadius={1}
      mb={2}
      bgcolor="secondary.contrastText">
      <Grid item m={1} display="flex">
        <Avatar
          sx={{
            backgroundColor: "background.default",
            color: "text.primary",
          }}>
          {getInitialsFromFullName(authorName)}
        </Avatar>

        <Grid item container ml={1} alignContent="center">
          <Grid item xs={12}>
            <Typography variant="subtitle2" fontWeight={300}>
              {authorName}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle1">
              {getReadableDateTimeString(createdDate)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} m={1}>
        <Typography
          variant="subtitle2"
          component="p"
          fontWeight={300}
          sx={{ overflowWrap: "break-word" }}>
          {content}
        </Typography>
      </Grid>
    </Grid>
  );
}
